import { themr } from '@nextiva/analytics-lib';
import { Select } from '@nextiva/next-ui';
import * as React from 'react';
import Styles from "./EntriesPerPage.css";

var makeOptions = function makeOptions(opts) {
  return opts.map(function (value) {
    return {
      value: value,
      label: String(value)
    };
  });
};

var DEFAULT_SIZE = 25;

function EntriesPerPage(_a) {
  var _b = _a.value,
      value = _b === void 0 ? DEFAULT_SIZE : _b,
      theme = _a.theme,
      onChange = _a.onChange;

  var handleChange = function handleChange(_a) {
    var v = _a.value;
    return onChange(v);
  };

  var options = makeOptions([25, 50, 75, 100]);
  return React.createElement("div", {
    className: theme.entriesPerPage,
    "data-test": "entries-per-page"
  }, React.createElement("span", null, "Show"), React.createElement(Select, {
    className: theme.select,
    options: options,
    value: value,
    onChange: handleChange
  }), React.createElement("span", null, "entries"));
} //@ts-ignore until typings in place


export default themr(React.memo(EntriesPerPage), Styles);